module.exports = __webpack_public_path__ + "static/media/23-5.e95d9311.mp3";